const initialState = {
  loading: false,
  totalSupply: 0,
  cost: 0,
  saleIsActive: false,
  maxBeers: 5000,
  maxMintAmount: 10,
  error: false,
  errorMsg: "",
};

const dataReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CHECK_DATA_REQUEST":
      return {
        ...state,
        loading: true,
        error: false,
        errorMsg: "",
      };
    case "CHECK_DATA_SUCCESS":
      return {
        ...state,
        loading: false,
        totalSupply: action.payload.totalSupply,
        cost: action.payload.cost,
        saleIsActive: action.payload.saleIsActive,
        maxBeers: action.payload.maxBeers,
        maxMintAmount: action.payload.maxMintAmount,
        error: false,
        errorMsg: "",
      };
    case "CHECK_PRESALE_DATA_SUCCESS":
      return {
        ...state,
        loading: false,
        presaleLimit: action.payload.presaleLimit,
        presaleCost: action.payload.presaleCost,
        balance: action.payload.balance,
        error: false,
        errorMsg: "",
      };
    case "CHECK_DATA_FAILED":
      return {
        ...initialState,
        loading: false,
        error: true,
        errorMsg: action.payload,
      };
    default:
      return state;
  }
};

export default dataReducer;
